<div class="page">
    <div class="title">
        <div class="titleValue">{{ "profile.title" | transloco }}</div>
        <div class="line"></div>
    </div>

    <div class="datos">
        <div class="titleForm">
            {{ "profile.userData" | transloco }}
        </div>
        <form [formGroup]="formDatos">
            <div class="inputDatosGroup">
                <mat-label class="labelDatos">{{ "general.name" | transloco }}</mat-label>
                <input class="inputDatos" matInput name="nombre" type="text" formControlName="nombre"
                    maxlength="200" />
            </div>

            <div class="inputDatosGroup" style="margin-top: 22px;">
                <mat-label class="labelDatos">{{ "general.surname" | transloco }}</mat-label>
                <input class="inputDatos" matInput name="apellidos" type="text" formControlName="apellidos"
                    maxlength="200" />
            </div>
        </form>

        <div class="titleForm" style="margin-top: 38px;">
            {{ "profile.addressTitle" | transloco }}
        </div>

        <form [formGroup]="formDireccion">
            <!-- <div class="inputDatosGroup">
                <mat-label class="labelDatos">PAÍS (*)</mat-label>
                <mat-select class="selectDatos" matSelect name="pais" formControlName="pais"
                    maxlength="200" (valueChange)="changePais($event)">
                    <mat-option *ngFor="let item of paises" [value]="item.id">{{item.pais}}</mat-option>
                </mat-select>
            </div>

            <div class="inputDatosGroup" style="margin-top: 22px;">
                <mat-label class="labelDatos">PROVINCIA (*)</mat-label>
                <mat-select class="selectDatos" [class.selectRegisterBlocked]="formDireccion.get('pais')?.value === ''" [disabled]="formDireccion.get('pais')?.value === ''" matSelect name="provincia" formControlName="provincia"
                    maxlength="200" (valueChange)="changeProvincia($event)">
                    <mat-option *ngFor="let item of provincias" [value]="item.idprovincia">{{item.provincia}}</mat-option>
                </mat-select>
            </div>

            <div class="inputDatosGroup" style="margin-top: 22px;">
                <mat-label class="labelDatos">POBLACIÓN (*)</mat-label>
                <mat-select class="selectDatos" [class.selectRegisterBlocked]="formDireccion.get('provincia')?.value === ''" [disabled]="formDireccion.get('provincia')?.value === ''" matSelect name="poblacion" formControlName="poblacion"
                    maxlength="200">
                    <mat-option *ngFor="let item of poblaciones" [value]="item.idpoblacion">{{item.poblacion}}</mat-option>
                </mat-select>
            </div> -->

            <div class="inputDatosGroup" style="margin-top: 22px;">
                <mat-label class="labelDatos">{{ "profile.address" | transloco }}</mat-label>
                <input class="inputDatos" matInput name="direccion" type="text" formControlName="direccion"
                    maxlength="200" />
            </div>

            <div class="inputDatosGroup" style="margin-top: 22px;">
                <mat-label class="labelDatos">{{ "general.postalCode" | transloco }}</mat-label>
                <input class="inputDatos" matInput name="codigoPostal" type="text" formControlName="codigoPostal"
                    maxlength="200" />
            </div>

            <div class="inputDatosGroup" style="margin-top: 22px;">
                <mat-label class="labelDatos">{{ "general.phone" | transloco }}</mat-label>
                <input class="inputDatos" matInput name="phone" type="tel" formControlName="phone"
                    maxlength="200" />
            </div>
        </form>

        <div class="actionButtons">
            <button class="buttonActualizar" (click)="updateUser()">{{ "profile.update" | transloco }}</button>
        </div>
    </div>
</div>
